import { Layout } from 'react-admin';
import CustomMenu         from './CustomMenu';
import CustomAppBar       from './CustomAppBar';
import TaskReminderBanner from './TaskReminderBanner';
import { AssistantProvider } from '../assistant/AssistantContext';
import AssistantWidget       from '../assistant/AssistantWidget';

// AssistantProvider mounts here — above the router, alongside the other
// "renders once, persists across route navigation" siblings — so the one
// shared conversation (see AssistantContext.js) survives navigating
// between CRM pages. AssistantWidget (bubble + compact panel) is the
// widget-shell rendering of that conversation; it hides itself on the
// /assistant route, where AssistantPage.js renders the full-page one.
const CustomLayout = (props) => (
  <AssistantProvider>
    <Layout {...props} menu={CustomMenu} appBar={CustomAppBar} />
    <TaskReminderBanner />
    <AssistantWidget />
  </AssistantProvider>
);

export default CustomLayout;
